/** API origin for auth and future admin endpoints. Empty string = same-origin (Nginx proxies /auth and /api). */
export function getApiOrigin(): string {
  const raw = ((import.meta.env.VITE_API_URL as string | undefined) ?? '').trim();
  return raw.replace(/\/$/, '');
}
